module.exports = __webpack_public_path__ + "static/media/cow-left.558d1c60.jpg";